export const listPendidikan = ["SMA/SMK", "D1", "D2", "D3", "S1", "S2", "S3"];
